class GoogleAnalyticsService {

  constructor() {
    this.firstTime  = false;
    this.trackingId = null;
  }

  init(trackingId) {
    /* eslint-disable no-undef, no-var, no-var, semi, no-empty */
    this.trackingId = trackingId;
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    /* eslint-enable no-undef, no-var, no-var, semi, no-empty */
  }

  eventPageView(url) {
    if(!this.firstTime) {
      this.firstTime = true;
      ga('create', this.trackingId, 'auto'); // eslint-disable-line no-undef
      ga('send', 'pageview'); // eslint-disable-line no-undef
    }
    else {
      ga('set', 'page', url); // eslint-disable-line no-undef
      ga('send', 'pageview'); // eslint-disable-line no-undef
    }
  }

}

export default new GoogleAnalyticsService();



// WEBPACK FOOTER //
// ./src/services/googleAnalytics.js